import styles from './Section.module.css';

const PADDING = {
  default: styles.section,
  tight: styles.tight,
  flush: styles.flush,
};

/** The centred content column. */
export function Wrap({ as: Tag = 'div', className = '', style, children, ...rest }) {
  return (
    <Tag className={`${styles.wrap} ${className}`.trim()} style={style} {...rest}>
      {children}
    </Tag>
  );
}

/**
 * A full-bleed band of the page.
 *
 * @param {'default'|'tight'|'flush'} padding vertical rhythm
 * @param {'light'|'alt'|'dark'} tone background treatment
 */
export function Section({
  padding = 'default',
  tone = 'light',
  className = '',
  children,
  ...rest
}) {
  return (
    <section
      className={`${PADDING[padding] ?? PADDING.default} ${className}`.trim()}
      data-tone={tone === 'light' ? undefined : tone}
      {...rest}
    >
      {children}
    </section>
  );
}

/** Heading block on the left, a trailing action or lede on the right. */
export function SectionIntro({ className = '', children, ...rest }) {
  return (
    <div className={`${styles.intro} ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
}

/**
 * `rowCascade` marks a grid whose siblings share a row, so struck rules
 * cascade across instead of striking as one. See motion.css.
 */
export function Grid({ cols = 3, rowCascade = false, className = '', children, ...rest }) {
  const colClass = { 2: styles.cols2, 3: styles.cols3, 4: styles.cols4 }[cols] ?? styles.cols3;
  return (
    <div
      className={`${styles.grid} ${colClass} ${className}`.trim()}
      {...(rowCascade ? { 'data-row-cascade': '' } : null)}
      {...rest}
    >
      {children}
    </div>
  );
}
